import { AssetDetailInfo } from '../components/atoms/asset-meta-card/asset-meta-card'
import { AnalyzeData } from '../components/molecules/analyze-table/AnalayzeTable'
import { CapsuleInfo } from '../pages/business-accounts/diagnostics'
import {
  AnalyzeDataEntity,
  BoardedTableData,
  CanBeAnything,
  TokenHealthTable,
  TokenStatus,
} from '../types'
import { t } from '../utils/i18n'

export const ToolTipTextOtherAccounts =
  'To add account, upload a supplement sheet with the required mappings via the Advertiser Setup page'

export enum CapsuleTitleInfo {
  OWNED_ACCOUNTS = 'Owned Accounts',
  CLIENT_ACCOUNTS = 'Partner Accounts',
  BUSINESS_USERS = 'Total Signed-up Business Users',
  FACEBOOK_PAGES = 'Facebook Pages',
  INSTAGRAM_ACCOUNTS = 'Instagram Accounts',
  DATASET = 'Dataset',
  CATALOGUE = 'Catalogue',
}

const capsuleData: CapsuleInfo[] = [
  {
    id: 1,
    title: CapsuleTitleInfo.OWNED_ACCOUNTS,
    subInfo: '',
    toolTipContent: `${t('toolTipOwnedAccount')}`,
  },
  {
    id: 2,
    title: CapsuleTitleInfo.CLIENT_ACCOUNTS,
    subInfo: '',
    toolTipContent: `${t('toolTipClientAccount')}`,
  },
  {
    id: 3,
    title: CapsuleTitleInfo.BUSINESS_USERS,
    subInfo: '',
    toolTipContent: `${t('toolTipBusinessAccount')}`,
  },
  {
    id: 4,
    title: CapsuleTitleInfo.FACEBOOK_PAGES,
    subInfo: '',
    toolTipContent: `${t('toolTipFBAccount')}`,
  },
  {
    id: 5,
    title: CapsuleTitleInfo.INSTAGRAM_ACCOUNTS,
    subInfo: '',
    toolTipContent: `${t('toolTipIGAccount')}`,
  },
  {
    id: 6,
    title: CapsuleTitleInfo.DATASET,
    subInfo: '',
    toolTipContent: `${t('toolTipDataset')}`,
  },
  {
    id: 7,
    title: CapsuleTitleInfo.CATALOGUE,
    subInfo: '',
    toolTipContent: `${t('toolTipCatalog')}`,
  },
]
export const mapCapsuleInfoWithMeta = (metaInfo: CanBeAnything) => {
  const mappedCapsuleInfo: CapsuleInfo[] = capsuleData.map((capsule) => {
    if (capsule.title === CapsuleTitleInfo.OWNED_ACCOUNTS) {
      capsule.subInfo =
        metaInfo['ownedAccountSync'] &&
        metaInfo['ownedAccountSync']?.onboardedAdAccountsCount !== undefined &&
        metaInfo['ownedAccountSync'].ownedAdAccountsCount !== undefined
          ? `${metaInfo['ownedAccountSync']?.onboardedAdAccountsCount} / ${metaInfo['ownedAccountSync'].ownedAdAccountsCount}`
          : 'N/A'
      capsule.count = metaInfo['ownedAccountSync']?.onboardedAdAccountsCount
    } else if (capsule.title === CapsuleTitleInfo.CLIENT_ACCOUNTS) {
      capsule.subInfo =
        metaInfo['clientAccountSync'] &&
        metaInfo['clientAccountSync'].onboardedClientAdAccountsCount !== undefined &&
        metaInfo['clientAccountSync'].clientAdAccountsCount !== undefined
          ? `${metaInfo['clientAccountSync'].onboardedClientAdAccountsCount} / ${metaInfo['clientAccountSync'].clientAdAccountsCount}`
          : 'N/A'
      capsule.count = metaInfo['clientAccountSync']?.onboardedClientAdAccountsCount
    } else if (capsule.title === CapsuleTitleInfo.BUSINESS_USERS) {
      capsule.subInfo =
        metaInfo['businessUsers'] &&
        metaInfo['businessUsers']['totalSignedUpUsers'] !== undefined &&
        metaInfo['businessUsers']['totalBusinessUsers'] !== undefined
          ? `${metaInfo['businessUsers']['totalSignedUpUsers']}/${metaInfo['businessUsers']['totalBusinessUsers']}`
          : 'N/A'
      capsule.count = metaInfo['businessUsers']?.totalSignedUpUsers
    } else if (capsule.title === CapsuleTitleInfo.FACEBOOK_PAGES) {
      const str =
        metaInfo['clientPageSync'] &&
        metaInfo['ownedPageSync'] &&
        metaInfo['clientPageSync']['onboardedClientPagesCount'] !== undefined &&
        metaInfo['ownedPageSync']['onboardedPagesCount'] !== undefined &&
        metaInfo['clientPageSync']['clientPagesCount'] !== undefined &&
        metaInfo['ownedPageSync']['ownedPagesCount'] !== undefined
          ? `${metaInfo['clientPageSync']['onboardedClientPagesCount'] + metaInfo['ownedPageSync']['onboardedPagesCount']}/${metaInfo['clientPageSync']['clientPagesCount'] + metaInfo['ownedPageSync']['ownedPagesCount']}`
          : 'N/A'
      capsule.subInfo = str
      capsule.count =
        metaInfo['clientPageSync']?.onboardedClientPagesCount +
        metaInfo['ownedPageSync']?.onboardedPagesCount
    } else if (capsule.title === CapsuleTitleInfo.INSTAGRAM_ACCOUNTS) {
      const str =
        metaInfo['instaAccountSync'] &&
        metaInfo['instaAccountSync']['onboardedInstaCount'] !== undefined &&
        metaInfo['instaAccountSync']['instaAccountsCount'] !== undefined
          ? `${metaInfo['instaAccountSync']['onboardedInstaCount']}/${metaInfo['instaAccountSync']['instaAccountsCount']}`
          : 'N/A'
      capsule.subInfo = str
      capsule.count = metaInfo['instaAccountSync']?.onboardedInstaCount
    } else if (capsule.title === CapsuleTitleInfo.DATASET) {
      const str =
        metaInfo['ownedPixleSync'] &&
        metaInfo['clientPixleSync'] &&
        metaInfo['ownedPixleSync']['onboardedPixlesCount'] !== undefined &&
        metaInfo['clientPixleSync']['onboardedClientPixlesCount'] !== undefined &&
        metaInfo['ownedPixleSync']['ownedPixlesCount'] !== undefined &&
        metaInfo['clientPixleSync']['clientPixlesCount'] !== undefined
          ? `${metaInfo['ownedPixleSync']['onboardedPixlesCount'] + metaInfo['clientPixleSync']['onboardedClientPixlesCount']}/${metaInfo['ownedPixleSync']['ownedPixlesCount'] + metaInfo['clientPixleSync']['clientPixlesCount']}`
          : 'N/A'
      capsule.subInfo = str
      capsule.count =
        metaInfo['ownedPixleSync']?.onboardedPixlesCount +
        metaInfo['clientPixleSync']?.onboardedClientPixlesCount
    } else if (capsule.title === CapsuleTitleInfo.CATALOGUE) {
      const str =
        metaInfo['ownedCatalogSync'] &&
        metaInfo['clientCatalogSync'] &&
        metaInfo['clientCatalogSync']['onboardedClientCatalogsCount'] !== undefined &&
        metaInfo['clientCatalogSync']['clientCatalogsCount'] !== undefined &&
        metaInfo['ownedCatalogSync']['ownedCatalogsCount'] !== undefined &&
        metaInfo['ownedCatalogSync']['onboardedCatalogsCount'] !== undefined
          ? `${metaInfo['ownedCatalogSync']['onboardedCatalogsCount'] + metaInfo['clientCatalogSync']['onboardedClientCatalogsCount']}/${metaInfo['ownedCatalogSync']['ownedCatalogsCount'] + metaInfo['clientCatalogSync']['clientCatalogsCount']}`
          : 'N/A'
      capsule.subInfo = str
      capsule.count =
        metaInfo['ownedCatalogSync']?.onboardedCatalogsCount +
        metaInfo['clientCatalogSync']?.onboardedClientCatalogsCount
    }

    return capsule
  })
  return mappedCapsuleInfo
}

export const generateCols = (
  list: BoardedTableData[],
  activetab: number,
  selectedCapsuleInfo: CapsuleInfo
) => {
  let tableCols: CanBeAnything[] = []
  let tableRowData: BoardedTableData[] = []

  if (selectedCapsuleInfo?.title === CapsuleTitleInfo.FACEBOOK_PAGES) {
    tableCols = [
      {
        key: 'pageId',
        label: 'Facebook Page Id',
        flexGrow: 1,
      },
      {
        key: 'pageName',
        label: 'Facebook Page Name',
        flexGrow: 1,
      },
    ]
    if (activetab === 1) {
      tableCols.push({
        key: 'cta',
        label: 'Diagnostics',
        flexGrow: 1,
        clickable: true,
      })
    }
  } else if (selectedCapsuleInfo?.title === CapsuleTitleInfo.INSTAGRAM_ACCOUNTS) {
    tableCols = [
      {
        key: 'instaId',
        label: 'Instagram Account Id',
        flexGrow: 1,
      },
      {
        key: 'instaName',
        label: 'Instagram Account Name',
        flexGrow: 1,
      },
    ]
    if (activetab === 1) {
      tableCols.push({
        key: 'cta',
        label: 'Diagnostics',
        flexGrow: 1,
        clickable: true,
      })
    }
  } else if (selectedCapsuleInfo?.title === CapsuleTitleInfo.DATASET) {
    tableCols = [
      {
        key: 'datasetId',
        label: 'Dataset Id',
        flexGrow: 1,
      },
      {
        key: 'datasetName',
        label: 'Dataset Name',
        flexGrow: 1,
      },
    ]
    if (activetab === 1) {
      tableCols.push({
        key: 'cta',
        label: 'Diagnostics',
        flexGrow: 1,
        clickable: true,
      })
    }
  } else if (selectedCapsuleInfo?.title === CapsuleTitleInfo.CATALOGUE) {
    tableCols = [
      {
        key: 'catalogId',
        label: 'Catalogue Id',
        flexGrow: 1,
      },
      {
        key: 'catalogName',
        label: 'Catalogue Name',
        flexGrow: 1,
      },
    ]
    if (activetab === 1) {
      tableCols.push({
        key: 'cta',
        label: 'Diagnostics',
        flexGrow: 1,
        clickable: true,
      })
    }
  } else {
    tableCols = [
      {
        key: 'accountId',
        label: 'Account ID',
        flexGrow: 1,
      },
      {
        key: 'accountName',
        label: 'Account Name',
        flexGrow: 1,
      },
      {
        key: 'statusType',
        label: 'Status',
        flexGrow: 1,
      },
    ]

    if (activetab === 1) {
      tableCols.push({
        key: 'cta',
        label: 'Diagnostics',
        flexGrow: 1,
        clickable: true,
      })
    }
  }

  if (activetab === 1) {
    tableRowData = list?.length ? [...list] : []
  }

  return {
    tableCols,
    tableRowData,
  }
}

export const generateBusinessUsersRowsAndCols = (businessUsersList: CanBeAnything[]) => {
  const tableCols = [
    {
      key: 'email',
      label: 'Email',
      flexGrow: 1,
    },
    {
      key: 'name',
      label: 'Name',
      flexGrow: 1,
    },
    {
      key: 'status',
      label: 'Status',
      flexGrow: 1,
    },
    {
      key: 'signUpStatus',
      label: 'SignUp',
      flexGrow: 1,
    },
  ]

  const tableRow = businessUsersList.map((list) => {
    return {
      ...list,
      // capitalizing the string
      signUpStatus:
        list.signUpStatus.charAt(0).toUpperCase() + list.signUpStatus.slice(1).toLowerCase(),
      status: list.status.charAt(0).toUpperCase() + list.status.slice(1).toLowerCase(),
    }
  })

  return {
    tableCols,
    tableRow,
  }
}

const filterItemsBasedOnParent = (
  items: CanBeAnything[],
  id: string,
  name: string,
  searchTerm: string
) => {
  return items.filter((item) => {
    if (
      item[id].toLowerCase().includes(searchTerm.toLowerCase()) ||
      item[name].toLowerCase().includes(searchTerm.toLowerCase())
    ) {
      return item
    }
  })
}

export const calcClientPagination = (
  list: CanBeAnything[],
  limit: number,
  page: number,
  searchTerm: string,
  activetab: number,
  selectedCapsuleInfo: CapsuleInfo
) => {
  let items = list?.slice((page - 1) * limit, page * limit)

  if (searchTerm) {
    if (
      selectedCapsuleInfo.title === CapsuleTitleInfo.OWNED_ACCOUNTS ||
      selectedCapsuleInfo.title === CapsuleTitleInfo.CLIENT_ACCOUNTS
    ) {
      items = filterItemsBasedOnParent(items, 'accountId', 'accountName', searchTerm)
    } else if (
      selectedCapsuleInfo.title === CapsuleTitleInfo.FACEBOOK_PAGES ||
      selectedCapsuleInfo.title === CapsuleTitleInfo.CATALOGUE
    ) {
      items = filterItemsBasedOnParent(items, 'pageId', 'pageName', searchTerm)
    } else if (selectedCapsuleInfo.title === CapsuleTitleInfo.INSTAGRAM_ACCOUNTS) {
      items = filterItemsBasedOnParent(items, 'instaId', 'instaName', searchTerm)
    } else if (selectedCapsuleInfo.title === CapsuleTitleInfo.DATASET) {
      items = filterItemsBasedOnParent(items, 'datasetId', 'datasetName', searchTerm)
    }
  }
  const { tableCols } = generateCols(list, activetab, selectedCapsuleInfo)
  return {
    rows: items,
    cols: tableCols,
  }
}

export const mapBusinessData = (data: CanBeAnything[]) => {
  return data?.map((item) => {
    return {
      ...item,
      cta: 'View',
      statusType: item?.status === 1 ? 'Active' : item?.status === -1 ? 'In progress' : 'Inactive',
    }
  })
}

export const mapFbPagesData = (data: CanBeAnything[]) => {
  return data?.map((item) => {
    return {
      ...item,
      cta: 'View',
    }
  })
}

export const mapAnalyzeData = (data: AnalyzeDataEntity) => {
  const tableData: AnalyzeData[] = []
  tableData.push(
    {
      keyName: 'Campaign Insights',
      delivered: data?.deliveredCampaignInsights,
      scheduled: data?.scheduledCampaignInsights,
    },
    {
      keyName: 'Campaign Optimization',
      delivered: data?.deliveredCampaignOptimizationAnalysis,
      scheduled: data?.scheduledCampaignOptimizationAnalysis,
    },
    {
      keyName: 'EOCR',
      delivered: data?.deliveredEOCRReports,
      scheduled: data?.scheduledEOCRReports,
    },
    {
      keyName: 'PCA',
      delivered: data?.deliveredPCAReports,
      scheduled: data?.scheduledPCAReports,
    },
    {
      keyName: 'Live Campaign Reports',
      delivered: data?.deliveredLiveReports,
      scheduled: data?.scheduledLiveReports,
    }
  )
  return tableData
}

export const mapBusinessAccountsData = (data: CanBeAnything[]) => {
  data.forEach((el) => {
    el.status = el.status.charAt(0).toUpperCase() + el.status.slice(1).toLowerCase()
  })
  return data
}

export const getNextSyncDate = (detail: AssetDetailInfo) => {
  return new Date(detail?.lastAttemptedAt + detail?.syncInterval)?.toLocaleString()
}
export const getFailedSyncMsg = (detail: AssetDetailInfo) => {
  let str = ''
  const lastAttemptedAt = new Date(detail?.lastAttemptedAt)?.toLocaleString()
  if (typeof detail?.error?.details === 'string') {
    str = t('meta.info.failed').replace('{{syncfailedmsg}}', `${detail?.error?.details}`)
  } else if (detail?.error?.details?.error?.message) {
    str = t('meta.info.failed').replace(
      '{{syncfailedmsg}}',
      `${detail?.error?.details?.error?.message}`
    )
  } else {
    str = t('meta.info.failed.nomsg')
  }

  str = `${str} \n Last Attempted at: ${lastAttemptedAt}`
  return str
}

const getErrorText = (el: CanBeAnything) => {
  let str = ''
  if (el?.error?.details && el?.error?.details?.error?.message) {
    str = el?.error?.details?.error?.message
  } else if (el?.error?.details) {
    str = t('token.error.hover')
  }
  return str
}

export const mapTokenHealthTableData = (data: CanBeAnything[]) => {
  const res: TokenHealthTable[] = []
  if (data.length) {
    data.forEach((el) => {
      res.push({
        category: el?.category,
        tokenStatus:
          el.status === 'OK' && el?.isOverriddenToken
            ? TokenStatus.HEALTHY
            : el.status !== 'OK' && el?.isOverriddenToken
              ? TokenStatus.ERROR
              : null,
        customToken: el?.isOverriddenToken ? 'Yes' : 'No',
        lastChecked: el?.lastCheckedAt ? new Date(el?.lastCheckedAt).toLocaleString() : '-',
        errorHoverText: getErrorText(el),
        name: el?.name,
      })
    })
  }
  return res
}

export function truncateString(str: string, maxLength: number): string {
  if (!str) return ''

  if (str.length > maxLength) {
    return str.slice(0, maxLength) + '...'
  }

  return str
}
